import styles from './suggestion.module.scss';

export const SearchSuggestionSkeleton: React.FC = () => {
  return (
    <div className={styles.skeleton} aria-hidden>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};
